(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define("MetricTree", ["d3"], factory);
	else if(typeof exports === 'object')
		exports["MetricTree"] = factory(require("d3"));
	else
		root["MetricTree"] = factory(root["d3"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 